exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700);", ""]);

// module
exports.push([module.id, "html, body, #root, .App {\n  width: 100%;\n  height: 100%;\n}\nbody {\n    font-family: 'Poppins', sans-serif;\n    background: #ffffff;\n\n    /* The image used */\n  background-image: url(" + require("../images/bg1.jpg") + ");\n\n  /* Full height */\n  height: 100%;\n\n  /* Center and scale the image nicely */\n  background-position: center;\n  background-size: cover;\n}\n\np {\n  word-wrap: break-word;\n  font-family: 'Poppins', sans-serif;\n  font-size: 1.1em;\n  font-weight: 300;\n  line-height: 1.7em;\n  /* color: #999; */\n}\n\n.App{\n  background: white;\n}\n\n#content {\n  background: white;\n}\n\n.pagination {\n  float: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/statics/css/app.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/statics/css/app.css
// module chunks = 0